import React, {Dispatch, SetStateAction} from "react"
import Button from "../../generic/buttons/Button"
import ClientInfo from "../ClientInfo"
import {useAppSelector} from "../../../hooks/redux"
import OrderHistory from "../OrderHistory"
import classes from "./ClientDetail.module.scss"

interface IClientDetailProps {
  modalEditToggle: Dispatch<SetStateAction<boolean>>
  modalDeleteToggle: Dispatch<SetStateAction<boolean>>
}

function ClientDetail({modalEditToggle, modalDeleteToggle}: IClientDetailProps) {

  const {client} = useAppSelector(state => state.client)

  return (
    <div className={classes.wrap}>
      <div className={classes.top}>
        <div className={classes.top_title}>Клиент</div>
        <div className={classes.top_buttons}>
          <Button
            color={"white"}
            size={"sm"}
            onClick={() => modalEditToggle(true)}
          >Редактировать</Button>
          <Button
            color={"white"}
            size={"sm"}
            onClick={() => modalDeleteToggle(true)}
          >Удалить</Button>
        </div>
      </div>
      <ClientInfo data={client} />
      <OrderHistory/>
    </div>
  )
}

export default ClientDetail